import { ENTITY_TYPES } from '@sales-center/common'
import { useCheckPermissions } from '@user/store/authorization/permissions/useCheckPermissions'
import { useMemo } from 'react'

type Props = {
  entity?: ENTITY_TYPES
}

export function useData(props: Props) {
  const { entity } = props
  const [canUpdateLeads, canUpdateOpps] = useCheckPermissions(
    'leads_update',
    'opportunities_update',
  )

  const canUpdate = useMemo(
    () => (entity === ENTITY_TYPES.Lead ? canUpdateLeads : canUpdateOpps),
    [canUpdateLeads, canUpdateOpps, entity],
  )

  return { canUpdate }
}
